export default "__VITE_ASSET__e44b8dd8__"